import { TFunction } from 'react-i18next';

import { ContactsList } from '@dev/ee-api/ee-api-models';

import { ListsState } from '@/store/lists/types';

export enum DropdownOptions {
    Edit = 'edit',
    Delete = 'delete',
    ViewContacts = 'viewcontacts',
    Copy = 'copy',
    Export = 'export',
    Randomlist = 'randomlist',
    Nthselectionlists = 'nthselectionlists',
    Addcontacts = 'addcontacts',
    Uploadcontacts = 'uploadcontacts',
}

export interface ContactsListsTableProps {
    perPage: number;
    activePage: number;
    search: string;
}

export interface SingleListMenuProps {
    list: ContactsList;
    index: number;
    perPage: number;
    activePage: number;
    search: string;
}

export interface HandleMenuClickParams {
    option: string;
    list: ContactsList;
    perPage: number;
    activePage: number;
    lists: ListsState;
    dispatch: any;
    t: TFunction;
    search: string;
}
